import { render } from "./Faq.vue?vue&type=template&id=e1e9bdc2&bindings={\"renderToc\":\"data\"}"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
script.render = render

export default script